import { doc, writeBatch, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase";
import { unlinkDeletedGoal } from "../statements/statementService";
import { unlinkGoalFromKeyDates } from "../keydates/keyDateService";

// Deletes a goal in one batch: its tasks lose their parent goal, and every vision statement, fear and Key
// Date that links to it loses the link. Rejects if anything fails, so the caller can say so; nothing is
// half-done. Finding the linked statements needs a connection.
export async function deleteGoal(uid, goalId, allTasks = []) {
  const batch = writeBatch(db);
  await Promise.all([unlinkDeletedGoal(batch, uid, goalId), unlinkGoalFromKeyDates(batch, uid, goalId)]);
  allTasks.filter(t => t.parentGoalId === goalId).forEach(t =>
    batch.set(doc(db, "users", uid, "tasks", t.id), { parentGoalId: null, updatedAt: serverTimestamp() }, { merge: true }));
  batch.delete(doc(db, "users", uid, "goals", goalId));
  return batch.commit();
}
